module.exports = __webpack_public_path__ + "img/util-pencil.bfcd33f0.svg";